export default function mapBy(array, key) {
  const map = {};

  if (array) {
    array.forEach(object => {
      map[object[key]] = object;
    });
  }

  return map;
}



// WEBPACK FOOTER //
// ./src/site-render/src/lib/mapBy.js